<template>
  <div v-if="result">
    <!-- 채점 완료 -->
    <mdb-btn v-if="result.score>=0" :color="color" class="w-90 p-0 m-0" @click="$emit('view-result')">
      {{result.score}}점</mdb-btn>
    <!-- 채점이 필요한 경우 - 답지는 있으나 점수가 없는 경우? -->
    <mdb-btn v-else-if="attitude && result.test" color="primary" class="w-90 p-0 m-0" @click="$emit('view-result')">채점</mdb-btn>
    <mdb-btn v-else-if="result.answer" color="primary" class="w-90 p-0 m-0" @click="$emit('view-result')">채점</mdb-btn>
    <div v-else class="text-center" style="font-size:13px">{{$strDate(result.testDate)}}</div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapGetters } from 'vuex';
export default {
  name: 'StaffTestResult',
  components: {},
  props: ['result', 'attitude'],
  data: () => ({
    TAG: 'StaffTestResult :'
  }),
  computed: {
    ...mapGetters('training', ['failScore']),
    color () {
      return this.result.score < this.failScore ? 'danger' : 'success'
    }
  }
}
</script>
